// src/hooks/useSecurityQuestionSubmit.ts
import { useState } from "react";
import { useHistory } from "react-router-dom";
import { AuthorizeSecurityQuestion, goToNextAuthStep } from "../actions/auth";
import { formatDateYYYYMMDD } from "../services/formatter";
import { useAppDispatch } from "../store/hooks";
import { trackEvent } from "../services/eventTracker";
import { EVENTS } from "../constants/events";
import { PAGES } from "../constants/localization";
import { ErrorObj } from "../types/errors";
import { SecurityQuestionFormValues } from "../types/components/SecurityQuestion";

export const useSecurityQuestionSubmit = () => {
  const dispatch = useAppDispatch();
  const history = useHistory();
  const [errors, setErrors] = useState<ErrorObj[] | null>(null);

  const onSubmit = async ({ answer }: SecurityQuestionFormValues) => {
    const value =
      answer instanceof Date ? formatDateYYYYMMDD(new Date(answer)) : answer;

    setErrors(null);

    try {
      await dispatch((AuthorizeSecurityQuestion as any)(value));
      trackEvent(EVENTS.LOGIN.SECURITY_QUESTION_SUBMITTED, { success: true });
      dispatch((goToNextAuthStep as any)(history));
    } catch (error) {
      const responseErrors = (error as any)?.response?.data?.errors;

      trackEvent(EVENTS.LOGIN.SECURITY_QUESTION_SUBMITTED, {
        success: false,
        failure_reason:
          responseErrors?.[0]?.errorMessage ?? PAGES.AUTH.GENERIC_ERROR_MESSAGE,
      });

      if (responseErrors) setErrors(responseErrors);
    }
  };

  return { onSubmit, errors };
};